import React from 'react';
import Modal from 'react-modal';

// Style for the modal (customize as needed)
const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
  },
};

// Make sure to set the appElement to comply with accessibility standards
Modal.setAppElement('#root');

function PopupDialog({ isOpen, onClose }) {
  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onClose}
      style={customStyles}
      contentLabel="Example Modal"
    >
    <h2>Enter Details</h2>
      {/* Your content for the popup dialog */} 
      <input type='date' className='form-control'></input>
      <input type='text' className='form-control'></input>

      <button onClick={onClose}>Close</button>
    </Modal>
  );
}

export default PopupDialog;
